import React, { useState, useEffect } from "react";
import "./../../pages/css/header.css";
import nlogo from "./../../assets/images/nhdcl_main_logo.png";
import glogo from "./../../assets/images/new_gyalsung_nobg.png";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (selector) => {
    if (location.pathname === "/") {
      if (selector === "top") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        document
          .querySelector(selector)
          ?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: selector } });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`header-wrapper ${isScrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        {/* Logo Section */}
        <Link to="/" className="header-logo-link">
          <div className="header-logos">
            <img
              className="header-logo nhdcl-logo"
              src={nlogo}
              alt="NHDCL Logo"
            />
            <div className="logo-divider"></div>
            <img
              className="header-logo gyalsung-logo"
              src={glogo}
              alt="Gyalsung Logo"
            />
          </div>
        </Link>

        {/* Navigation Menu */}
        <nav className="header-nav">
          <button onClick={() => handleNavClick("top")} className="nav-link">
            Home
          </button>
          <button
            onClick={() => handleNavClick(".academies-container")}
            className="nav-link"
          >
            Academies
          </button>
          <button
            onClick={() => handleNavClick(".mr-container")}
            className="nav-link"
          >
            Maintenance
          </button>
        </nav>

        {/* Actions Section */}
        <div className="header-actions">
          <button
            onClick={() => handleNavClick(".mr-container")}
            className="cadet-cta-btn"
          >
            <span>Quick Report</span>
            <div className="cta-pulse"></div>
          </button>

          <Link to="/login" className="header-login-btn">
            <span>Login</span>
            <svg
              className="login-icon"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z"
                fill="currentColor"
              />
            </svg>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
